export const isMenuId = (id: string): boolean => {
  return id.startsWith('MENU_') || id.startsWith('SUBMENU_')
}
